import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      OOPSS_TECHNICAL_ISSUES: "Ops! Tekniske problemer...",
      WE_ARE_WORKING_ON_RESOLVING_IT:
        "Vi jobber med å løse dette! Vennligst prøv igjen senere, eller kontakt vår kundeservice.",
      CONTACT_CUSTOMER_SERVICE: "Kontakt kundeservice",
      BACK_TO_MY_ACCOUNT: "Tilbake til Min konto",
    },
    se: {
      OOPSS_TECHNICAL_ISSUES: "Hoppsan, tekniska problem...",
      WE_ARE_WORKING_ON_RESOLVING_IT:
        "Vi jobbar på att lösa det! Försök igen senare eller kontakta vår kundtjänst.",
      CONTACT_CUSTOMER_SERVICE: "Kundtjänst",
      BACK_TO_MY_ACCOUNT: "Tillbaka til Mitt konto",
    },

    dk: {
      OOPSS_TECHNICAL_ISSUES: "Hov, tekniske problemer...",
      WE_ARE_WORKING_ON_RESOLVING_IT:
        "Vi arbejder på at finde en løsning hurtigst muligt! Prøv venligst igen senere eller kontakt vores kundeservice.",
      CONTACT_CUSTOMER_SERVICE: "Kontakt kundeservice",
      BACK_TO_MY_ACCOUNT: "Tilbage til min konto",
    },
  } as const
)[language];
